import api from "@/api";

const namespaced = true

const state = {
  spotCosts: [],
  routes: [],
  owners: [],
  spotCostsFiles: {}
}

const getters = {
  spotCosts: state => state.spotCosts,
  routes: state => state.routes,
  owners: state => state.owners,
  spotCostsFiles: state => state.spotCostsFiles
}

const mutations = {
  SET_SPOT_COSTS: (state, payload) => {
    state.spotCosts = payload
  },
  SET_ROUTES: (state, payload) => {
    state.routes = payload
  },
  SET_OWNERS: (state, payload) => {
    state.owners = payload
  },
  SET_SPOT_COSTS_FILES: (state, payload) => {
    state.spotCostsFiles = payload
  }
}

const actions = {
  async fetchSpotCosts({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']

      if (payload && payload.hasOwnProperty('sort_dir')) {
        payload ['sort_dir'] = payload['sort_dir'].toUpperCase()
      }
      const filter = {
        search: filterConfig.search,
        page: filterConfig.currentPage,
        limit: filterConfig.pageSize,
        is_master_data: true,
        type: 'SPOT',
        ...payload
      }

      const { data } = await api.getContracts(filter)
      if (data.error) {
        commit('SET_SPOT_COSTS', [])
        commit('Table/SET_TOTAL_DATA', 0, { root: true })
        commit('Table/SET_TOTAL_PAGE', 1, { root: true })
        return
      }

      commit('SET_SPOT_COSTS', data.data)
      commit('Table/SET_TOTAL_DATA', data.total, { root: true })
      commit('Table/SET_TOTAL_PAGE', data.pages, { root: true })
    } catch (err) {
      throw err
    }
  },
  async fetchOwners({ commit }) {
    try {
      const { data } = await api.getMasterDropdown({ type: 'CONTRACTOR' })
      if (data.error) {
        commit('SET_OWNERS', [])
        return
      }

      commit('SET_OWNERS', data)
    } catch (err) {
      throw err
    }
  },
  async fetchRoutes({ commit }) {
    try {
      const { data } = await api.getRoutes()
      if (data.error) {
        commit('SET_ROUTES', [])
      }
      commit('SET_ROUTES', data)
    } catch (err) {
      throw err
    }
  },
  async postSpotCost(_, payload) {
    try {
      await api.postSpotCost(payload)
    } catch ({ data }) {
      throw data
    }
  },
  async putSpotCost(_, payload) {
    try {
      await  api.putSpotCost(payload.id, payload.form)
    } catch ({ data }) {
      throw data
    }
  },
  async deleteSpotCost(_, payload) {
    try {
      await api.deleteSpotCost(payload)
    } catch (err) {
      throw err
    }
  },
  async downloadSpotCosts({ commit, rootGetters }, payload) {
    try {
      const filterConfig = rootGetters['Table/defaultConfig']
      const response = await  api.getSpotCostsExcelDownload({
        search: filterConfig.search,
        ...payload
      })
      if (response) {
        commit('SET_SPOT_COSTS_FILES', response)
      }
    } catch (err) {
      throw err
    }
  },
  resetSpotCostsFiles({ commit }) {
    commit('SET_SPOT_COSTS_FILES', {})
  }
}

export default { namespaced, state, getters, mutations, actions }